import { NotificationBarCallbackReason } from 'owa-notification-bar';

/**
 * The options for the notification bar itself
 */
export interface CalendarNotificationOptions {
    icon?: string;
    minWidth?: number;
    maxWidth?: number;
    shouldShowDismissIcon?: boolean;
    shouldShowSpinner?: boolean;
    allowAutoDismiss?: boolean;
    isHovered?: boolean;
    autoDismissInSeconds?: number;
}

/**
 * The custom calendar notification callback reasons
 */
export enum CustomNotificationBarCallbackReason {
    // starting from 11 in case additional callback reasons get added to original NotificationBarCallbackReason enum
    ForceDismissedFromCode = 11,
}

/**
 * The union type for callback reasons for calendar notifications
 */
export type CalendarNotificationBarCallbackReason =
    | CustomNotificationBarCallbackReason
    | NotificationBarCallbackReason;

/**
 * The options for the action button in the notification bar, if any
 */
export interface CalendarNotificationButtonOptions {
    primaryActionText: string;
    callbackOptions?: CalendarNotificationCallbackOptions;
    notificationCallback?: (reason: CalendarNotificationBarCallbackReason) => void;
}

/**
 * The callback functions for the notification bar button
 */
export interface CalendarNotificationCallbackOptions {
    primaryActionClickedCallback: () => void;
    dismissedCallback?: () => void;
}
